// ** React Imports
import { Fragment, useState, useEffect } from "react";
import { Badge } from "reactstrap";
// ** Custom Components
import NavbarUser from "./NavbarUser";
import NavbarBookmarks from "./NavbarBookmarks";
import CommonModal from "../../../../ui/components/Modal";
import KeyFeatures from "../../../../ui/components/KeyFeatures";
import minimize from "../../../../assets/images/logo/minimize.svg";
import maximize from "../../../../assets/images/logo/maximize.svg";

import "./index.css";
import "../../../../../src/ui/scss/common.scss";

const ThemeNavbar = (props) => {
    // ** Props
    const { skin, setSkin, setMenuVisibility, menuCollapsed, setMenuCollapsed } = props;
    const cuurrentModuleName = localStorage.getItem("currentModule");

    // state
    const [modal, setModal] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);

    //function for set display width

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener("resize", handleWindowSizeChange);
        return () => {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);

    // function for  open and close model
    const toggleHandler = () => {
        setModal(!modal);
    };

    const isMobile = width <= 768;
    const isMobileModal = width <= 1200;

    useEffect(() => {
        (isMobile || isMobileModal) && setMenuCollapsed(false);
        localStorage.setItem("isMobile", isMobile);
    }, [isMobile, isMobileModal]);

    return (
        <Fragment>
            <div className={`bookmark-wrapper d-flex align-items-center`}>
                <div className="d-flex align-items-center">
                    <img
                        src={menuCollapsed ? minimize : maximize}
                        className="mx-md-1 mx-0 cursor-pointer header-icon-width"
                        alt="maximize"
                        onClick={() => {
                            !isMobile && !isMobileModal && setMenuCollapsed(menuCollapsed ? false : true);
                            setMenuVisibility(true);
                        }}
                    />

                    <h3 className="m-0 text-black fw-bold line-height-0 current-module-name">{cuurrentModuleName}</h3>
                    {!isMobile && (
                        <Badge
                            className="text-capitalize border border-danger align-item-center key-features mx-1 cursor-pointer"
                            color="light-danger"
                            onClick={toggleHandler}
                        >
                            Key Features
                        </Badge>
                    )}
                </div>
                <NavbarBookmarks setMenuVisibility={setMenuVisibility} />
            </div>
            <NavbarUser skin={skin} setSkin={setSkin} isMobile={isMobile} toggleHandler={toggleHandler} />
            <CommonModal
                modal={modal}
                setModal={setModal}
                title={"Key Feature"}
                toggleHandler={toggleHandler}
                // loading={loader}
            >
                <KeyFeatures />
            </CommonModal>
        </Fragment>
    );
};

export default ThemeNavbar;
